import { getLocalization } from 'a/selectors/languageSelectors';
import { spanishBookIds } from 'a/hub/data/BookIds';
import { getBookGameId } from 'root/lib/utilityFunctions';
import { LOCALIZATIONS } from 'lib/constants';

export const isCurrentBookSpanish = ({ eReader: { gameDetailsReducer } }) => {
  const gameId = getBookGameId(gameDetailsReducer.bookId);

  return Object.values(spanishBookIds).includes(gameId);
};

export const getEreaderLanguage = (state) => {
  const productLocalization = getLocalization(state);
  const hasSpanishLicense = productLocalization === LOCALIZATIONS.SPA_ES_DEFAULT;

  return hasSpanishLicense && isCurrentBookSpanish(state) ? LOCALIZATIONS.SPA_ES_DEFAULT : LOCALIZATIONS.EN;
};
